<template>
  <div class="Background">

    <div style="display: flex; justify-content: space-between;">
      <h2 class="Title">
        사용자 등록
      </h2>

      <div class="link_location">
        설정관리 <v-icon small class="mdi mdi-chevron-right" />
        일반설정 <v-icon small class="mdi mdi-chevron-right" />
        <a href="/admin/user_create">사용자 등록</a>
      </div>
    </div>

    <v-card class="pa-5" elevation="0">

      <v-card-text>
        <v-row>
          <v-col>
            <h4 style="color:black;">유저 이름</h4>
            <v-form ref="nameForm" v-model="valid" lazy-validation>
              <v-text-field v-model="name" :rules="nameRules" :counter="10" placeholder="이름" 
                ref="nameInput" color="#777"/>
            </v-form>
          </v-col>
        </v-row>

        <v-row class="mt-0">
          <v-col>
            <h4 style="color:black;">이메일</h4>
            <v-form ref="emailForm" v-model="valid" lazy-validation>
              <v-text-field v-model="email" :rules="rules.emailRules" placeholder="이메일" ref="emailInput" class="pl-0" color="#777"/>
            </v-form>
          </v-col>
        </v-row>

        <v-row class="mt-0">
          <v-col>
            <h4  style="color:black;">암호</h4>
            <v-form ref="passwordForm" v-model="valid" lazy-validation>
              <v-text-field v-model="password" :rules="passwordRules" type="password" placeholder="암호"
                ref="passwordInput" color="#777"/>
            </v-form>
          </v-col>
        </v-row>

      </v-card-text>

      <v-card-title>
        <v-row>
          <v-col>
            <h4>메뉴</h4>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col class="mr-2">
            <v-card link elevation="0" class="menu_icon" :class="{ active: isAllActive() }"
              @click="handleMenuClick('ALL')">
              <v-icon large class="mdi mdi-apps mb-2" color="#006cea"></v-icon>
              <h4>ALL</h4>
            </v-card>
          </v-col>
          <v-col class="mr-2" v-for="menu in menus" :key="menu.id">
            <v-card :link="true" elevation="0" class="menu_icon" :class="{ active: activeMenu.includes(menu.id) }"
              @click="handleMenuClick(menu.id)">
              <v-icon large :class="menu.iconClass" color="#006cea"></v-icon>
              <h4>{{ menu.title }}</h4>
            </v-card>
          </v-col>
        </v-row>

      </v-card-text>
    </v-card>
    <v-row justify="end" class="bg-purple mt-3 mr-0">
      <v-col v-for="count in 1" :key="count" cols="auto">
        <TextButton buttonText="취소" class="mr-2" @click="cancel" />
        <TextButton buttonText="등록" :loading="loadingCreate" @click="createUser" isPrimary />
      </v-col>
    </v-row>

    <div v-if="loadingCreate" class="loading-overlay">
      <div class="spinner"></div>
    </div>

    <AppSnackbar :message="snackbarText" :visible="snackbar" :error="snackbarError" />

  </div>
</template>

<script>
import TextButton from '@/components/ui/button/TextButton2.vue';
import UserApi from '@/api/user/UserApi';
import AppSnackbar from "@/components/ui/snackbar/Snackbar.vue";


export default {
  components: {
    TextButton,
    AppSnackbar
  },
  data() {
    return {
      activeMenu: [],
      menus: [
        { id: '2', title: '동영상 관리', iconClass: 'mdi mdi-video-outline mb-2' },
        { id: '3', title: '플레이리스트', iconClass: 'mdi mdi-playlist-play mb-2' },
        { id: '5', title: '템플릿', iconClass: 'mdi mdi-animation-play-outline mb-2' },
        { id: '8', title: '라이브 관리', iconClass: 'mdi mdi-access-point mb-2' },
        { id: '9', title: '레코딩 관리', iconClass: 'mdi mdi-record-rec mb-2' },
        { id: '16', title: '업로드 옵션', iconClass: 'mdi mdi-cog-outline mb-2' },
        { id: '10', title: '전체 통계', iconClass: 'mdi mdi-chart-box-outline mb-2' },
        { id: '11', title: 'VOD 통계', iconClass: 'mdi mdi-weather-cloudy mb-2' },
        { id: '12', title: 'Live 통계', iconClass: 'mdi mdi-cards-heart-outline mb-2' },
        // { id: '2', title: '동영상 관리', iconClass: 'mdi mdi-video-outline mb-2' },
        // { id: '3', title: '플레이리스트', iconClass: 'mdi mdi-playlist-play mb-2' },
        // { id: '4', title: '소셜 업로드', iconClass: 'mdi mdi-cast mb-2' },
        // { id: '6', title: '템플릿', iconClass: 'mdi mdi-animation-play-outline mb-2' },
        // { id: '9', title: '라이브 관리', iconClass: 'mdi mdi-access-point mb-2' },
        // { id: '10', title: '레코딩 관리', iconClass: 'mdi mdi-record-rec mb-2' },
        // { id: '17', title: '업로드 옵션', iconClass: 'mdi mdi-cog-outline mb-2' },
        // { id: '11', title: '전체 통계', iconClass: 'mdi mdi-chart-box-outline mb-2' },
        // { id: '12', title: 'VOD 통계', iconClass: 'mdi mdi-weather-cloudy mb-2' },
        // { id: '13', title: 'Live 통계', iconClass: 'mdi mdi-cards-heart-outline mb-2' },
      ],
      loadingCreate: false,
      name: '',
      email: '',
      password: '',
      passwordRules: [
        v => !!v || 'Password is required',
        v => (v && v.length >= 8) || 'Password must be at least 8 characters long',
        v => /[A-Z]/.test(v) || 'Password must contain at least one uppercase letter',
        v => /[a-z]/.test(v) || 'Password must contain at least one lowercase letter',
        v => /\d/.test(v) || 'Password must contain at least one digit',
        v => /[-!$%^&*()_+|~=`{}\[\]:";'<>?,.\/]/.test(v) || 'Password must contain at least one special character',
      ],
      nameRules: [
        v => !!v || 'Name is required',
        //v => /^[a-zA-Z][a-zA-Z0-9]*$/.test(v) || 'Must start with a letter and can use letters and numbers',
        v => !v || /^[a-zA-Zㄱ-ㅎ가-힣][a-zA-Z0-9ㄱ-ㅎ가-힣]*$/.test(v) || 'Must start with a letter and can use letters, numbers, and Korean characters',
        v => !v || v && v.length >= 2 && v.length <= 50 || 'Name must be between 2 and 50 characters',
      ],
      rules: {
        emailRules: [
          // v => !v || 'Email is required',
          // v => !v || /.+@.+\..+/.test(v) || "Invalid email address."

          v => !!v || 'Email is required',
          v => /.+@.+\..+/.test(v) || 'Invalid email address.'
        ],
      },
      valid: '',
      snackbar: false,
      snackbarText: '',
      snackbarError: false,
      snackbarErrorText: '',
      loadingCreate: false,
    }
  },
  created() {
    this.activeMenu = this.menus.map(menu => menu.id);
  },
  methods: {
    handleMenuClick(menuId) {
      if (menuId === 'ALL') {
        if (this.isAllActive()) {
          this.activeMenu = [];
        } else {
          this.activeMenu = this.menus.map(menu => menu.id);
        }
      } else {
        const index = this.activeMenu.indexOf(menuId);
        if (index === -1) {
          this.activeMenu.push(menuId);
        } else {
          this.activeMenu.splice(index, 1);
        }
      }
    },
    isAllActive() {
      return this.activeMenu.length === this.menus.length;
    },
    async createUser() {
      this.loadingCreate = true;
      const data = {
        name: this.name,
        email: this.email,
        password: this.password,
        activeMenu: this.activeMenu
      }
      const response = await UserApi.register(data);

      if(response.status == 201){
        setTimeout(() => {
            this.loadingCreate = false;
            this.snackbar = true;
            this.snackbarText = '생성 성공';
            this.snackbarError = false;
            setTimeout(() => {
              this.$router.push({ path: '/admin/user' });
              this.snackbar = false;
            }, 2000);
        }, 1000);
      } else if(response.status == 422) {
        setTimeout(() => {
              this.loadingCreate = false;
              this.snackbar = true;
              this.snackbarError = true;

              const err = response.response.data.error;

              if (err.name) {
                this.snackbarText = String(response?.response?.data?.error?.name) ?? '유효성 검사 실패';
              }
              if (err.email) {
                this.snackbarText = String(response?.response?.data?.error?.email) ?? '유효성 검사 실패';
              }
              if (err.password) {
                this.snackbarText = String(response?.response?.data?.error?.password) ?? '유효성 검사 실패';
              }

              // this.snackbarText = String(response.response.data.error.name);
              // this.snackbarText = String(response?.response?.data?.error?.name) ?? '유효성 검사 실패';

              setTimeout(() => {
                this.snackbar = false;
              }, 2000);
          }, 1000);
      } else {
        setTimeout(() => {
              this.loadingCreate = false;
              this.snackbar = true;
              this.snackbarError = true;
              this.snackbarText = '생성 실패';
              setTimeout(() => {
                this.snackbar = false;
              }, 2000);
          }, 1000);
      }
    },
    cancel() {
      this.$router.push({ path: '/admin/user' });
    },
  }
}
</script>

<style lang="scss" scoped>
.menu_icon {
  text-align: center;
  padding: 20px;
  background: #f8f8f8;
}

.menu_icon {
  cursor: pointer;
}

.menu_icon.active {
  background-color: #b9d8fb;
}
.v-text-field.v-text-field--enclosed .v-text-field__details {padding: 0!important;}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid rgba(255, 255, 255, 0.3);
  border-top: 5px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
</style>